/** Login Activity API — Faz 1.4 createApi factory. */
import {createApi} from './_factory'
import type {AccountNs, CommonNs} from '@shared/types'

const api = createApi('login-activity')

export const LoginActivityApi = {
  getLoginActivities: () =>
    api.get<AccountNs.LoginActivity[]>('user-logins'),
  logoutFromDevice: (loginId: string) =>
    api.get<AccountNs.LoginActivity[]>(`delete-user-login/${loginId}`),
  logoutFromAllDevices: () =>
    api.post<void, CommonNs.AnyResponse | Error>('delete-all-user-logins'),
}
